import {crearHash} from "../Funciones/crearHash";
import {obtenerConsecutivo} from "../../Servicios/BD/Consecutivos/obtenerConsecutivo";
import {registrarMovimiento} from "../Movimientos/registrarMovimiento";
import {aumentarConsecutivo} from "../../Servicios/BD/Consecutivos/aumentarConsecutivo";
import {adap_cange_mov} from "../Adaptadores/adap_cange_mov";

export const realizarCange = async ({usuario, puntos, premio, entidad}) => {


    let doxConsecutivo = await obtenerConsecutivo({col: 'consecutivos', id: 'movimientos'})

    let cange = {
        nombre: usuario.nombre,
        codigo: usuario.codigo,
        correo: usuario.correo,
        valor: puntos * -1,
        fecha: new Date().getTime(),
        idUsuario: usuario.id,
        consecutivo: doxConsecutivo.data,
        detalle: `${puntos} Puntos por ${premio.nombre}`,
        metodo: premio.nombre,
    }


    cange.hashString = JSON.stringify(cange)
    cange.hash = crearHash({text: cange.hashString})


    let dox = await registrarMovimiento({
        movimiento: adap_cange_mov({usuario: usuario, cange: cange, metodo: premio.nombre, datos: entidad}),
        estado: 'Validando',
    })

    await aumentarConsecutivo({col: 'consecutivos', id: 'movimientos', actual: cange.consecutivo})

    return dox

}
